import { render, staticRenderFns } from "./courseInfo.vue?vue&type=template&id=00893b8e&scoped=true&"
import script from "./courseInfo.vue?vue&type=script&lang=js&"
export * from "./courseInfo.vue?vue&type=script&lang=js&"
import style0 from "./courseInfo.vue?vue&type=style&index=0&id=00893b8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00893b8e",
  null
  
)

export default component.exports